import {Card, Row, Tag} from "antd";
import { styled } from "styled-components";

export const StyledCard = styled(Card)`
  margin-top:               5vh;
  min-width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .ant-card-body {
display: flex;
    align-content:                    center;
    align-items:                  center;
    text-align:                 center;
    justify-content:                      center;
  }
`;
export const StyledTag = styled(Tag)`
    display: flex;
    justify-content: space-around;
`;
